import React from 'react';
import { Button } from 'antd';
import { ButtonGroup } from '@common/components';
import { OfferChangeRequestType } from '@applicant-flow/graphql';

export function OfferChangeRequestActions({
  offerState,
  offerChangeRequests,
  onChangeResponse,
}: {
  offerState?: string;
  offerChangeRequests?: OfferChangeRequestType[];
  onChangeResponse: (edit: boolean) => void;
}) {
  const hasPendingChangeRequested = offerState === 'change_requested';
  const changeRequests = offerChangeRequests || [];
  const lastChangeRequest = changeRequests?.[changeRequests?.length - 1];
  const canCreateResponse = lastChangeRequest?.canCreateResponse?.value;

  return (
    hasPendingChangeRequested &&
    canCreateResponse && (
      <ButtonGroup>
        <Button
          key="replyWithoutEditingOffer"
          size="large"
          onClick={() => onChangeResponse(false)}
        >
          Reject Changes
        </Button>
        <Button
          key="editOffer"
          size="large"
          type="primary"
          onClick={() => onChangeResponse(true)}
        >
          Update Offer
        </Button>
      </ButtonGroup>
    )
  );
}
